import { formatDate } from "@/lib/api";
import { EntityManager } from "./EntityManager";

const fields = [
  { name: "title", label: "Titre", required: true },
  { name: "edition", label: "Édition (ex. N°2 — Juillet 2026)" },
  { name: "description", label: "Description", type: "textarea", rows: 3, full: true },
  { name: "pdf_url", label: "Fichier PDF", type: "file", accept: "application/pdf", placeholder: "Téléverser le PDF du magazine", full: true },
  { name: "cover_url", label: "Couverture", type: "file", accept: "image/*", placeholder: "Téléverser la couverture", full: true },
];
const columns = [
  { key: "title", label: "Magazine", render: (m) => <div><div className="font-semibold">{m.title}</div><div className="text-xs text-zinc-500">{m.edition}</div></div> },
  { key: "pdf_url", label: "PDF", render: (m) => <span className={`text-xs font-bold ${m.pdf_url ? "text-green-600" : "text-red-600"}`}>{m.pdf_url ? "Disponible" : "Manquant"}</span> },
  { key: "published_at", label: "Publié le", render: (m) => formatDate(m.published_at) },
];

const DEFAULTS = { title: "Chronique Magazine", edition: "", description: "", pdf_url: "", cover_url: "" };

export default function MagazinesManager() {
  return <EntityManager title="Magazine" description="Déposez les éditions PDF lisibles dans la liseuse en ligne." listUrl="/magazines" baseUrl="/magazines" fields={fields} columns={columns} testId="magazines" defaults={DEFAULTS} />;
}
